import { ToggleIncentive } from '@components/incentives/toggle-incentive';
import { TextHeader } from '@components/ui/text-header';
import { CampaignTriggerTokenSettings } from '@givz/core-client';
import { useCoreClientMutation } from '@queries/client';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import {
  Chip,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { donorAppRoutes, routes } from '@routes';
import { motion } from 'framer-motion';
import { FunctionComponent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CopyLinkButton } from '../copy-link-button';
import { DuplicateIncentiveButton } from '../duplicate-incentive/duplicate-incentive-button';
import { PreviewLinkButton } from '../preview-link-button';

export const Incentives: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data, mutate: getAllIncentives } = useCoreClientMutation({
    mutationFn: (client) => client.Hosted.campaigns.getAll,
  });

  useEffect(() => {
    getAllIncentives({ body: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={3}>
      {data?.data?.campaigns.map((incentive) => {
        const isGenerator =
          (incentive.trigger.settings as CampaignTriggerTokenSettings)
            ?.creationPolicy === 'PUBLIC';

        return (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={incentive.gid}>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
            >
              <Paper elevation={2}>
                <Stack direction="column" spacing={0} padding={1}>
                  <Stack
                    padding={1}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Chip
                      label={isGenerator ? 'Link Generator' : 'Credit Based'}
                    />
                    <ToggleIncentive
                      gid={incentive.gid}
                      initialStatus={incentive.status}
                    />
                  </Stack>
                  <Typography variant="h1" alignSelf="center">
                    ${incentive.offer.settings.value}
                  </Typography>
                  <Stack
                    direction="row"
                    padding={1}
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ cursor: 'grab' }}
                  >
                    <TextHeader
                      title={incentive.name}
                      titleProps={{
                        fontWeight: 700,
                        variant: 'body1',
                      }}
                      subtitle={incentive.gid}
                      subtitleProps={{
                        variant: 'body2',
                      }}
                    />

                    <Stack direction="row">
                      {incentive.slug && (
                        <CopyLinkButton
                          text={donorAppRoutes
                            .generator({
                              queryParams: {},
                              slug: incentive.slug,
                            })
                            .toString()}
                        />
                      )}
                      {incentive.slug && (
                        <PreviewLinkButton
                          url={donorAppRoutes
                            .generator({
                              queryParams: { preview: '1' },
                              slug: incentive.slug,
                            })
                            .toString()}
                        />
                      )}
                      <DuplicateIncentiveButton
                        gid={incentive.gid!}
                        name={incentive?.name}
                      />
                      <Tooltip title="Edit Incentive">
                        <IconButton
                          onClick={() =>
                            navigate(routes.editIncentive(incentive.gid))
                          }
                        >
                          <EditSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Stack>
              </Paper>
            </motion.div>
          </Grid>
        );
      })}
    </Grid>
  );
};
